import React from "react";
import {Helmet} from "react-helmet";
import {ViviaWisperwind} from "../../constants/meta";

export const A36Meta = () => (
    <Helmet>
            <meta name="twitter:card" value="summary"/>
            <meta name="twitter:site" value="@VieuniteHQ"/>
            <meta name="twitter:title" value="Vieunite Artist | Marcos Micozzi & Hef Prentice"/>
            <meta name="twitter:description"
                  content=". Vieunite provides a dedicated digital canvas to extend their open chain of sensory translation, visualising Marcos Micozzi and Hef Prentice’s spatial audio architecture as an immersive digital art experience.  "/>
            <meta name="twitter:url" value="https://vieunite.com/artists/ marcos-micozzi-&-hef-prentice "/>
            <meta name="twitter:image"
                  value="https://vieunite.com/images/vieunite_sc_marcos_micozzi_&_hef_prentice.jpg"/>

            <meta property="og:url" content="https://vieunite.com/artists/marcos-micozzi-&-hef-prentice"/>
            <meta property="og:type" content="website"/>
            <meta property="og:title" content="Vieunite Artist | Marcos Micozzi & Hef Prentice"/>
            <meta property="og:description"
                  content=" Vieunite provides a dedicated digital canvas to extend their open chain of sensory translation, visualising Marcos Micozzi and Hef Prentice’s spatial audio architecture as an immersive digital art experience.  "/>
            <meta property="og:image" content="https://vieunite.com/images/vieunite_sc_marcos_micozzi_&_hef_prentice.jpg"/>

    </Helmet>);